import { Tab, Tabs, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSobreNosTab } from "../../../../contexts/SobreNosTabContext";
import {
  SobreNosNavigateState,
  SobreNosSubPageEnum,
} from "../../SobreNosSubPageEnum";
import Diretores from "./diretores";
import Historia from "./historia";
import Identidade from "./identidade";
import styles from "./styles.module.css";
import { sxTab, sxTabsContainer } from "./sxProps";
import Unidades from "./unidades";

const readInitialSubPage = (
  state: unknown
): SobreNosSubPageEnum | undefined => {
  const s = state as SobreNosNavigateState | null;
  if (s?.initialSobreNosSubPage === SobreNosSubPageEnum.Unidades) {
    return SobreNosSubPageEnum.Unidades;
  }
  return undefined;
};

const SobreNos = () => {
  const isMobile = useMediaQuery("(max-width: 899px)");
  const location = useLocation();
  const [subPageContent, setSubPageContent] = useState<SobreNosSubPageEnum>(
    () =>
      readInitialSubPage(location.state) ?? SobreNosSubPageEnum.História
  );
  const { setActiveTab } = useSobreNosTab();

  useEffect(() => {
    const fromNavigate = readInitialSubPage(location.state);
    if (fromNavigate === SobreNosSubPageEnum.Unidades) {
      setSubPageContent(SobreNosSubPageEnum.Unidades);
    }
  }, [location.key, location.state]);

  useEffect(() => {
    switch (subPageContent) {
      case SobreNosSubPageEnum.História:
        setActiveTab("sobre-nos-historia");
        break;
      case SobreNosSubPageEnum.Identidade:
        setActiveTab("sobre-nos-identidade");
        break;
      case SobreNosSubPageEnum.Unidades:
        setActiveTab("sobre-nos-unidades");
        break;
      case SobreNosSubPageEnum.Diretores:
        setActiveTab("sobre-nos-historia");
        break;
      default:
        setActiveTab("sobre-nos-historia");
    }
  }, [subPageContent, setActiveTab]);

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: SobreNosSubPageEnum
  ) => {
    setSubPageContent(newValue);
  };

  return (
    <div className={styles["sobre-nos-content"]}>
      <Tabs
        value={subPageContent}
        onChange={handleChange}
        centered={!isMobile}
        orientation={isMobile ? "vertical" : "horizontal"}
        variant="fullWidth"
        scrollButtons={false}
        sx={sxTabsContainer}
        TabIndicatorProps={{
          style: { backgroundColor: isMobile ? "transparent" : "#1C3775" },
        }}
      >
        <Tab sx={sxTab} label="História" value={SobreNosSubPageEnum.História} />
        <Tab
          sx={sxTab}
          label="Identidade"
          value={SobreNosSubPageEnum.Identidade}
        />
        <Tab
          sx={sxTab}
          label="Diretores"
          value={SobreNosSubPageEnum.Diretores}
        />
        <Tab sx={sxTab} label="Unidades" value={SobreNosSubPageEnum.Unidades} />
      </Tabs>
      {subPageContent === SobreNosSubPageEnum.História && <Historia />}
      {subPageContent === SobreNosSubPageEnum.Identidade && <Identidade />}
      {subPageContent === SobreNosSubPageEnum.Diretores && <Diretores />}
      {subPageContent === SobreNosSubPageEnum.Unidades && <Unidades />}
    </div>
  );
};

export default SobreNos;
